import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import moment from 'moment';
import { BsButton } from '../../collection/bootstrap/BootstrapComponents';
import DataTable from '../../collection/DataTable';
import TableHandler from '../../collection/TableHandler';
import DiasLibresFilter from '../../components/filters/DiasLibresFilter';
import DiasLibresModal from '../../components/modals/DiasLibresModal';
import FloatingAddButton from '../../components/project/FloatingAddButton';
import { apiDelete, apiGet, apiForm, getSession } from '../../utils/api';
import { sortableString, generateFormData } from '../../utils/functions';

export default function DiasLibres(props) {
    const usuario = getSession();
    // default filter
    const defaultFilter = {
        desde: moment().startOf('year').format("YYYY-MM-DD"),
        hasta: moment().endOf('year').format("YYYY-MM-DD"),
        trabajador: props.super ? null : usuario.id
    };
    let filter = generateFormData(defaultFilter);

    // api calls
    const updateData = async newFilter => {
        filter = newFilter ? newFilter : filter;
        return await apiForm("diasLibres/table", filter);
    };
    const deleteRow = async id => await apiDelete("diasLibres/delete/" + id);
    const performAction = async (action, id) => await apiGet(`diasLibres/${action}/${id}`);

    // render
    return <>
        <h2>{`${props.super ? "Administrar" : "Ver"} días libres`}</h2>
        <TableHandler
            onUpdate={updateData}
            onDelete={deleteRow}
            onAction={performAction}
            elementText="el día libre">
            <DiasLibresFilter
                className="my-3" fem
                defaultValue={defaultFilter}
                selectDepartamento={props.super && usuario.permisoAdmin}
                selectTrabajador={props.super} />
            <DiasLibresTable super={props.super} />
        </TableHandler>
    </>;
}

function DiasLibresTable(props) {
    // table columns
    const columns = [
        {
            name: "Trabajador",
            selector: row => sortableString(row.NombreTrabajador),
            format: row => row.NombreTrabajador,
            sortable: true,
            omit: !props.super
        },
        {
            name: "Día",
            selector: row => row.Dia,
            format: row => moment(row.Dia).format("DD/MM/YYYY"),
            sortable: true
        },
        {
            name: "Comentario",
            selector: row => sortableString(row.Comentario),
            format: row => row.Comentario,
            sortable: true
        }
    ];
    // table buttons
    const buttons = <>
        <BsButton variant="secondary" size="sm" onClick={props.onEdit}><FontAwesomeIcon icon={faEdit} /></BsButton>
        <BsButton variant="danger" size="sm" onClick={props.onDelete}><FontAwesomeIcon icon={faTrash} /></BsButton>
    </>;

    // render
    const name = row => `${row.NombreTrabajador} - ${moment(row.Dia).format("DD/MM/YY")}`;
    return <>
        <DataTable responsive columns={columns} data={props.data} rowname={name} buttons={props.super && buttons} pagination />
        {props.formOpen && (
            <DiasLibresModal
                show={props.formOpen}
                onHide={props.onFormClose}
                id={props.formId}
            />
        )}
        {props.super &&
            <FloatingAddButton onClick={props.onNew} />
        }
    </>;
}
